
class InvoiceFileCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
    }

    private _fileInfo:FileAttachment = null;
    set item(info:FileAttachment){
        this._fileInfo = info;
        // FileAttachment has a 'url' property but no 'name'/'filename'.
        // Parse the display name from the URL path (strip query params and decode).
        let displayName = MIOLocalizeString("UNKNOWN_FILE", "Unknown file");
        if (info.url) {
            let path = info.url.split("?")[0];
            let segments = path.split("/");
            let last = segments[segments.length - 1];
            if (last) displayName = decodeURIComponent(last);
        }
        this.nameLabel.text = displayName;
    }

    get fileInfo():FileAttachment {
        return this._fileInfo;
    }
}

